import api from './api';

const userService = {
  // Get current user's information
  getCurrentUser: async () => {
    try {
      const response = await api.get('/users/me');
      return response.data;
    } catch (error) {
      console.error('Error fetching current user:', error);
      throw error;
    }
  },

  // Update user's theme preference
  updateThemeColor: async (color) => {
    try {
      if (typeof color !== 'string' || !color.trim()) throw new Error('themeColor must be a non-empty string');
      const response = await api.put('/users/theme-color', { themeColor: color });
      return response.data;
    } catch (error) {
      console.error('Error updating theme preference:', error);
      throw error;
    }
  }
};

export default userService;
